import axios, { AxiosResponse } from 'axios';
import { FetchUserMenuType } from '../redux/lounges/slice';
import { Lounge, MyStore } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { sharedRequest } from './sharedRequest';
export const getUserMenuApi = async ({ loginuserid }: FetchUserMenuType) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const token = localStorage.getItem('token');
  const apiEndpoint = GET_BASE_URL + '/api/v1/getAssignMenuByAdmin';

  // LeftLounge and the page both load the menu on mount; share one request
  // per signed-in user.
  const userKey = `${localStorage.getItem('user_id') ?? 'guest'}:${token ? 1 : 0}`;
  const { data } = await sharedRequest(`userMenu:${userKey}`, 60000, () =>
    axios
      .get<MyStore[]>(`${apiEndpoint}`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then(responseBody)
  );

  return data;
};
